/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny, ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';
import { DeliveryOption } from '@msdyn365-commerce/retail-proxy';
import { getDeliveryOptionsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/StoreOperationsDataActions.g';

/**
 * Input class for get delivery options data action.
 */
export class GetDeliveryOptionsInput implements IActionInput {

    public getCacheKey = () => 'GetDeliveryOptions';

    public getCacheObjectType = () => 'DeliveryOption';

    public dataCacheType = (): CacheType => 'application';
}

/**
 * Creates the input required to make the retail api call.
 * @param inputData
 */
const createInput = (inputData: ICreateActionContext<IGeneric<IAny>>): GetDeliveryOptionsInput => {
    return new GetDeliveryOptionsInput();
};

const getDeliveryOptionsAction = async (
    input: GetDeliveryOptionsInput,
    ctx: IActionContext
): Promise<DeliveryOption[]> => {
    if (input) {
        return getDeliveryOptionsAsync({ callerContext: ctx }).then(response => {
            return response;
        });
    }

    ctx.trace('[get-delivery-options]Invalid input passed to action');
    return <DeliveryOption[]>{};
};

export default createObservableDataAction({
    id: 'defa/retail-actions/get-delivery-options',
    action: <IAction<DeliveryOption[]>>getDeliveryOptionsAction,
    input: createInput
});
